import { useQuery } from '@tanstack/react-query';

import { authClient } from '../auth/client';
import { useAuth } from '../auth/hooks';

/**
 * Hook to fetch the active organization for the current user
 * Returns the organization data from the session's activeOrganizationId
 */
export function useActiveOrganization() {
  const { data: session } = useAuth();
  const organizationId = session?.session?.activeOrganizationId;

  return useQuery({
    queryKey: ['organization', organizationId],
    queryFn: async () => {
      if (!organizationId) {
        return null;
      }

      const { data, error } = await authClient.organization.getFullOrganization({
        query: {
          organizationId,
        },
      });

      if (error) {
        throw new Error('Failed to fetch organization');
      }

      return data;
    },
    enabled: !!organizationId,
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: false,
  });
}
